import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { VideoIconComponent } from "./video-icon.component";
import { SafeUrlPipeline } from "../_helpers/pipe.module";

// Small, dependency-light module so any feature module can use <app-video-icon>
// and the safeUrl pipe without pulling in the whole SharedModule (which would
// create a circular dependency for modules that SharedModule already imports).
@NgModule({
    imports: [
        CommonModule,
        TranslateModule
    ],
    declarations: [
        VideoIconComponent,
        SafeUrlPipeline
    ],
    exports: [
        VideoIconComponent,
        SafeUrlPipeline
    ]
})
export class VideoIconModule {
    constructor() { }
}
